import { useEffect } from 'react';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import assistLogo from './imgs/0016_assist-card 1.svg';

import { useHistory } from 'react-router';
import { ASSIST } from '@shared/helpers/routes';
import { useDispatch } from 'react-redux';
import {
  saveSearchAssistDetails,
  setFormNoViaja,
  setFormPassengers,
  setFormContact,
} from '@shared/redux/actions';

import { sxStyle } from './cabecera-styles';

const ERROR_CONFIG = {
  ISSUANCE_ALREADY_DONE: {
    message:
      'Uno o más de los pasajeros ya cuenta con asistencia emitida para la fecha.',
  },
};

const DEFAULT_ERROR = {
  message:
    'El pago ha sido realizado con éxito, deberá comunicarse con la sucursal seleccionada para finalizar la emisión',
};

const Cabecera = ({ codeLoc, email, code, isSuccessPayment }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    const refId = document.getElementById('exitoContainerId');
    refId?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    dispatch(
      saveSearchAssistDetails({
        checkIn: null,
        checkOut: null,
        totalNights: null,
        destination: null,
        passengers: [],
        id_user: null,
        family_plan: false,
      })
    );
    dispatch(setFormPassengers({ pasajeros: null }));
    dispatch(setFormNoViaja({ noViaja: null }));
    dispatch(setFormContact({ contact: null }));
  }, []);

  const isRealSuccess = !!codeLoc;

  const specialMessage = ERROR_CONFIG[code]?.message;
  const defaultMessage = DEFAULT_ERROR.message;

  let messages = [];

  if (specialMessage) {
    messages.push(specialMessage);
  }

  if (isSuccessPayment) {
    messages.push(defaultMessage);
  }

  if (!specialMessage && !isSuccessPayment) {
    messages.push(defaultMessage);
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={sxStyle.gridExitoContainer}
        id="exitoContainerId"
      >
        <Box sx={sxStyle.divExitoContainer}>
          {isRealSuccess ? (
            <>
              <CheckCircleIcon sx={sxStyle.iconExitoContainer} />
              <Typography sx={sxStyle.title}>
                <span>¡Tu asistencia médica fue emitida con éxito!</span>
              </Typography>
              <Typography sx={sxStyle.codes}>
                Código de localizador
                <Typography
                  component="span"
                  sx={theme => ({
                    ...sxStyle.codesValue(theme),
                    ml: '5px',
                  })}
                >
                  {codeLoc}
                </Typography>
              </Typography>
              <Typography sx={sxStyle.email}>
                Pronto recibirás el Voucher en tu correo {email}
              </Typography>
            </>
          ) : (
            <>
              <CancelIcon sx={sxStyle.iconErrorContainer} />

              <Typography sx={sxStyle.errorTitle}>
                <span>¡La cobertura no se emitió correctamente!</span>
              </Typography>

              {messages.map(msg => (
                <Typography key={`${code}-${msg}`} sx={sxStyle.email}>
                  {msg}
                </Typography>
              ))}
            </>
          )}
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            <Grid sx={sxStyle.assistLogoContainer}>
              <Box
                component="img"
                src={assistLogo}
                alt="logo"
                sx={sxStyle.assistLogo}
              />
            </Grid>
            <Grid item xs={12} sx={sxStyle.boxNuevaReservaButton}>
              <Button
                sx={{
                  ...sxStyle.nuevaReservaButton,
                  '&:hover': {
                    border: `1px solid ${theme.primary}`,
                    color: theme.text1,
                    backgroundColor: theme.primary,
                  },
                }}
                onClick={() => {
                  history.push({ pathname: ASSIST, state: {} });
                }}
              >
                Buscar un nuevo destino
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </div>
  );
};

export default Cabecera;
